export const customerSortOptions = [
  { value: "newest", label: "Newest" },
  { value: "booking", label: "Bookings: Highest to Lowest" },
  { value: "revenue", label: "Revenue: Highest to Lowest" },
  { value: "balance", label: "Wallet Balance: Highest to Lowest" },
  { value: "cancellation", label: "Cancellations: Highest to Lowest" },
];

export const bookingSortOptions = [
  { value: "newest", label: "Newest" },
  { value: "price", label: "Price Highest to Lowest" },
  { value: "wallet", label: "Wallet Highest to Lowest" },
  { value: "passengers", label: "Passengers Highest to Lowest" },
];

export const operatorSortOptions = [
  { value: "newest", label: "Newest Operator" },
  { value: "bookings", label: "Bookings Highest to Lowest" },
  { value: "fleet_size", label: "Fleet Size Highest to Lowest" },
  { value: "revenue", label: "Revenue Highest to Lowest" },
];

export const busSortOptions = [
  { value: "newest", label: "Newest Bus" },
  { value: "bookings", label: "Bookings Highest to Lowest" },
  { value: "fleet_size", label: "Fleet Size Highest to Lowest" },
  { value: "revenue", label: "Revenue Highest to Lowest" },
];

export const couponSortOptions = [
  { value: "", label: "Sort By" },
  { value: "usage", label: "Usage Highest to Lowest" },
  { value: "value", label: "Value Highest to Lowest" },
];

export const citySortOptions = [
  { value: "Newest City", label: "Newest City" },
  { value: "operators", label: "Operators Highest to Lowest" },
  { value: "Buses", label: "Buses Highest to Lowest" },
  { value: "Users", label: "Users Highest to Lowest" },
  { value: "Bookings", label: "Bookings Highest to Lowest" },
  { value: "Revenue", label: "Revenue Highest to Lowest" },
  { value: "Cancellations", label: "Cancellations Highest to Lowest" },
];

export const settlementStatusSortOptions = [
  { value: "pending", label: "Pending" },
  { value: "failed", label: "Failed" },
  { value: "settled", label: "Settled" },
];

export const settlementSortOptions = [
  { value: "", label: "Sort By" },
  { value: "asc", label: "Asscending" },
  { value: "desc", label: "Descending" },
];
